export default {
  "layout": {
    "rows": [
      {
        "fields": [
          {
            "name": "defrag.aliquotsInSameContainer",
            "labelCode": "containers.move_aliquots_together",
            "type": "radio",
            "options": [
              { "value": true,  captionCode: "common.yes" },
              { "value": false, captionCode: "common.no" }
            ],
            "optionsPerRow": 2
          }
        ]
      }
    ]
  }
}
